import BaseModel from './BaseModel';

export default class PrintTemplate extends BaseModel {
  constructor({id, designation, customReport = false}) {
    super(id, null, designation);
    this.customReport = customReport;
  }

  get fastModeBrowserDesignation() {
    return this.designation || this.id;
  }

  static getPrefixIcon(printTemplate) {
    if (printTemplate?.customReport) {
      return 'custom_report';
    }
    return null;
  }

  static factory() {
    return new PrintTemplate({});
  }
}
